import React, { useImperativeHandle, useRef, useState } from "react";
import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import { ResidentModel } from "app/services/api/types/residents/models/ResidentModel";
import { ModifyResidentRef } from "app/features/residents/templates/interfaces";
import { View } from "ui/atoms/view";
import { Button, ButtonText } from "ui/gluestack/button";
import { ResidentProvider } from "app/features/residents/provider/ResidentProvider";
import { ResidentVaccinationsFormTemplate } from "../modify/ResidentVaccinationsFormTemplate";
import { ResidentMedicalHistoryFormTemplate } from "../modify/ResidentMedicalHistoryFormTemplate";
import { FormButtons } from "../../molecules/FormButtons";

interface Ref {
  show: (initialResident?: ResidentModel) => void;
}

const EditResidentVaccinationsModal = React.forwardRef<Ref, unknown>(
  (_, ref) => {
    const [showing, setShowing] = useState(false);
    const [initialResident, setInitialResident] = useState<ResidentModel>();
    const editVaccinesRef = useRef<ModifyResidentRef>(null);

    useImperativeHandle(ref, () => ({
      show: (initialResident?: ResidentModel) => {
        setInitialResident(initialResident);
        setShowing(true);
      },
    }));

    const handleClose = () => {
      setShowing(false);
    };

    const handleSave = async () => {
      const respVaccines = await editVaccinesRef.current?.continue();
      if (respVaccines) setShowing(false);
    };

    return (
      <ReusableModal
        isVisible={showing}
        onClose={handleClose}
        className="w-full max-w-[984px] mx-auto"
        title={`Vaccinations`}
        hasCancelButton
        isEditing
      >
        <ResidentProvider residentModel={initialResident}>
          <>
            <ResidentVaccinationsFormTemplate ref={editVaccinesRef} />

            <FormButtons onClose={handleClose} onSave={handleSave} />
          </>
        </ResidentProvider>
      </ReusableModal>
    );
  },
);

EditResidentVaccinationsModal.displayName = "EditResidentVaccinationsModal";
export { EditResidentVaccinationsModal };
